<template>
  <div id="base" class="">

    <!-- Unnamed (图片) -->
    <div id="u60" class="ax_default image">
      <img id="u60_img" class="img " src="@/images/shenqin/u51.png"/>
    </div>

    <!-- Unnamed (图片) -->
    <div id="u61" class="ax_default image">
      <img id="u61_img" class="img " src="@/images/shenqin/u52.png"/>
    </div>

    <!-- Unnamed (矩形) -->
    <div id="u62" class="ax_default box_1">
      <div id="u62_div" class=""></div>
    </div>

    <!-- Unnamed (水平线) -->
    <div id="u63" class="ax_default line">
      <img id="u63_img" class="img " src="@/images/shenqin/u55.png"/>
    </div>

    <!-- Unnamed (矩形) -->
    <div id="u64" class="ax_default label">
      <div id="u64_div" class=""></div>
      <div id="u64_text" class="text ">
        <p style="text-align:center;"><span>河北省体育局版权所有 主办：河北省体育局 </span></p>
        <p style="text-align:center;"><span>地址：河北省石家庄市中山东路372号 邮编：050011 邮箱：hebeitiyuju@163.com </span></p>
        <p style="text-align:center;"><span>网站运维电话：0311-85266259 冀ICP备：2022017224号 冀公网安备：13010202002305号 </span></p>
        <p style="text-align:left;"><span><br></span></p>
      </div>
    </div>

    <!-- Unnamed (矩形) -->
    <div id="u65" class="ax_default label">
      <div id="u65_div" class=""></div>
      <div id="u65_text" class="text ">
        <p><span>申请注意事项</span></p>
      </div>
    </div>

    <!-- Unnamed (矩形) -->
    <div id="u66" class="ax_default label">
      <div id="u66_div" class=""></div>
      <div id="u66_text" class="text ">
        <p><span>一、适用范围</span></p>
        <p><span>本标准所称非学科体育类校外培训机构（以下简称体育校外培训机构）是指，根据国家义务教育阶段《体育与健康》课程方案和课程标准的目标及内容，从事面向义务教育阶段学生，开展相关专项运动技能非学历教育培训,并在市场监管或民政部门依法注册登记的机构。</span>
        </p>
        <p><span>本标准不适用于各级体育行政部门所辖运动项目管理中心、体校、场馆等企事业单位，所述相关单位面向各类人群包括青少年群体提供体育训练、运动场所（地）等体育服务，依然按照工作职责依法依规开展。</span></p>
        <p><span>二、基本条件</span></p>
        <p><span>在本省行政区域内设立体育类校外培训机构，应当符合下列基本条件：</span></p>
        <p><span>（一）符合相关规定的举办者；</span></p>
        <p><span>（二）具有必要的组织机构、规范的章程和健全的管理制度；</span></p>
        <p><span>（三）具有充足稳定的开办培训资金；</span></p>
        <p><span>（四）具有与所开办培训项目相适应的培训目标、培训计划以及符合要求的培训内容材料等；</span></p>
        <p><span>（五）具有与培训类别、层次、规模相适应的，有资质的从业人员；</span></p>
        <p><span>（六）具有符合国家标准的培训场所（地）及设施器材；</span></p>
        <p><span>（七）体育主管部门出具的批准证书或批准意见；</span></p>
        <p><span>（八）法律法规规章及相关文件规定的其他条件。</span></p>
        <p><span>三、党组织建设</span></p>
        <p><span>体育校外培训机构应全面贯彻党的教育方针，符合党组织组建条件的，应当建立中国共产党基层组织，依照法律、行政法规和国家有关规定参与本培训机构重大决策并实施监督。</span></p>
        <p><span>四、机构设置</span></p>
        <p><span>（一）举办者</span></p>
        <p><span>体育校外培训机构的举办者可以为法人单位或自然人，应当符合下列条件：</span></p>
        <p><span>1.法人单位应具有中华人民共和国独立法人资格，信用状况良好，未被列入企业经营异常名录或严重违法失信名单。法人单位的法定代表人应具有中华人民共和国国籍；信用状况良好，无犯罪记录；具有政治权利和完全民事行为能力。</span>
        </p>
        <p><span>2.自然人应具有中华人民共和国国籍，在中国境内定居；信用状况良好，无犯罪记录；具有政治权利和完全民事行为能力。</span></p>
        <p><span>3.中小学校不得举办或参与举办体育校外培训机构。外商投资企业以及外方为实际控制人的社会组织不得举办、参与举办或者实际控制培训机构。</span></p>
        <p><span>（二）责任者</span></p>
        <p><span>法定代表人，应具有中华人民共和国国籍，在中国境内定居；信用状况良好，无犯罪记录；具有政治权利和完全民事行为能力。</span></p>
        <p><span>行政负责人，应为专职，依法行使教育教学和行政管理权，可由法定代表人担任。具有中华人民共和国国籍，在中国境内定居；具有政治权利和完全民事行为能力；信用状况良好，无违法违规记录；身体健康，年龄不超过70周岁；五年及以上相关教育管理经验。</span>
        </p>
        <p><span>（三）机构名称</span></p>
        <p><span>体育类校外培训机构名称应符合国家行政法规的有关规定，名称中不得含有歧义或误导性词汇，应符合《企业名称登记管理规定》《民办非企业单位名称管理暂行规定》《体育类民办非企业单位登记审查与管理暂行办法》的规定。本标准实施前已登记设立的体育类校外培训机构，其名称可以继续沿用。</span>
        </p>
        <p><span>（四）决策机构、章程及规章制度</span></p>
        <p><span>体育校外培训机构应按照法律法规设立决策机构，依法依规制定章程和内部管理规章制度。应符合《中华人民共和国公司法》《民办非企业单位登记管理暂行条例》等法律法规和规章要求。决策机构成员由举办者或者其代表、行政负责人和教职工代表等组成。已成立基层党组织的，党组织书记应通过法定程序进入决策机构。</span>
        </p>
        <p><span>（五）开办资金及经费保障</span></p>
        <p><span>体育校外培训机构应当具有与所设置培训项目和规模相适应的资金投入，稳定的办学经费来源。开办注册资本须符合《中华人民共和国公司法》《公司注册资本登记管理规定》《民办非企业单位登记管理暂行条例》等相关法律法规要求。</span>
        </p>
        <p><span>注册资金原则上不少于30万元人民币。</span></p>
        <p><span>五、培训场所（地）设施及相关安全保障</span></p>
        <p><span>（一）培训场所（地）</span></p>
        <p><span>体育校外培训机构应当具有与培训项目和培训规模相适应的培训场所及设施，并符合下列条件：</span></p>
        <p><span>1.必须有符合安全条件的固定且独立使用的场所（地），场所（地）的房屋（不动产）产权清晰。如系租赁，应签署2年及以上的有效租赁协议（或合同）。</span></p>
        <p><span>2.体育类校外培训机构办学场所（地）建筑面积应不少于200平方米，其中，教学场所（地）使用面积不少于办学场所（地）总建筑面积的2/3。棋牌类体育项目每班次培训的人均培训面积不小于3平方米，其他体育项目每班次培训的人均培训面积不小于5平方米（人均培训面积=培训场所（地）总面积/同一时间场上学员人数，其中培训场所（地）总面积指用于培训的教学面积，不包括配套服务场所面积）。培训场所（地）应预留安全距离，确保不拥挤、易疏散，具备与所开展体育培训运动项目相适应的场所（地）空间。</span>
        </p>
        <p><span>3.不得使用居民住宅、地下室、半地下室及其他存在安全隐患的场所。</span></p>
        <p><span>4.施行“一点一证”，一个固定且独立使用的场所（地）或培训点只能申办设立一个体育校外培训机构，且不能与学科类培训机构共同使用。未经审批机关批准，不得擅自变更办学培训地址、增设分支机构或培训点。</span>
        </p>
        <p><span>（二）设施器材</span></p>
        <p><span>体育校外培训机构用于开展校外体育培训的体育场地应符合全国性单项体育协会的相关规则，体育器材应符合国家相关产品标准。开展高危体育项目的校外体育培训，体育场地应符合国家规定的开放条件与技术要求，相关体育设施符合国家标准。要按照采光和照明国家有关标准，落实好青少年近视防控要求。室内场地应在主要位置悬挂中华人民共和国国旗。</span>
        </p>
        <p><span>（三）安全保障</span></p>
        <p><span>体育校外培训机构办学培训场所（地）必须符合国家关于安全、质检、消防、环保、卫生等相关管理规定要求，并达到下列要求：</span></p>
        <p><span>1.办学场地应达到《建筑设计防火规范》和《民用建筑工程室内环境污染控制规范》要求，并依法通过房屋安全鉴定、消防行政许可（备案），采光、照明、通风、排水良好。要建立“人防、物防、技防”三位一体的安全防范体系，实现视频监控全覆盖，视频图像能清晰辨认人员体貌特征。</span>
        </p>
        <p><span>2.制定意外突发状况处置预案（如地震、火灾、学员严重受伤等），每年至少组织一次演练。其中具有一定危险性的体育类培训项目，机构应做好防护措施，设立警示标牌，并配备基本医疗用品。</span></p>
        <p><span>3.培训机构应对从业人员进行设施操作、消防安全、应急救护等方面培训，购买经营场所责任险、培训人员人身意外险等，从事高危项目培训的机构应购买专门保险，防范和化解安全事故风险。</span></p>
        <p><span>4.体育培训场所应将各类安全制度、安全注意事项和特殊要求、平面示意图及疏散通道指示图等悬挂在明显位置；设置醒目的安全指示标志，并确保安全疏散通道畅通。</span></p>
        <p><span>5.体育类校外培训机构同一时间开展两项及以上体育项目，各体育项目培训区域之间应设置连续性隔离带。首节培训课应包括安全教育内容。</span></p>
        <p><span>6.体育类校外培训机构应配备常规医疗急救药品及设备，包括消毒包扎药物材料等。鼓励配备自动体外除颤仪（AED）。机构应根据自身规模配备不少于1名经过培训并获得急救证书的人员。</span></p>
        <p><span>7.体育培训场所应实行培训人员健康准入制度，公共用品、器材应选择合适的方式进行常态化清洁、消毒，保证消毒效果。发生疫情时，积极配合防疫部门处置措施。</span></p>
        <p><span>8.体育类校外培训机构应配备不少于1名专（兼）职安保人员，应掌握治安、消防等知识和相关法律法规，熟练使用通信、治安和消防器材。</span></p>
        <p><span>六、从业人员</span></p>
        <p><span>（一）基本条件</span></p>
        <p><span>从业人员包括教学人员、教研人员和其他人员。教学人员是指承担培训授课的人员；教研人员是指培训研究的人员；其他人员是指助教、带班人员等辅助人员。教学、教研人员应熟悉体育教学规律和学生身心发展特点。体育校外培训机构必须有相对稳定的从业人员，须具备以下条件：</span>
        </p>
        <p><span>1.爱国守法，恪守宪法原则。必须遵守宪法和法律，依法履行各项职责，身体健康，热爱教育事业，具有良好的思想品德和职业道德，具备与所开展体育培训运动项目相应专业水平的培训能力。</span></p>
        <p><span>2.教学人员、教研人员应持有以下至少一种证书：</span></p>
        <p><span>体育职教人员职称证书；</span></p>
        <p><span>社会体育指导员职业资格证书；</span></p>
        <p><span>全国性单项体育协会颁发的体育技能等级证书；</span></p>
        <p><span>体育教师资格证书；</span></p>
        <p><span>经人力资源和社会保障部确定的人才评价机构颁发的体育职业技能等级证书；</span></p>
        <p><span>经省级（含）以上体育行政部门认可的相关证书。</span></p>
        <p><span>其他符合要求的从业资格（能力）证明。</span></p>
        <p><span>3.非中小学、幼儿园在职教师。</span></p>
        <p><span>4.聘请在境内的外籍人员应符合国家有关规定，严禁聘请在境外的外籍人员开展培训活动。</span></p>
        <p><span>5.符合教育部、人力资源和社会保障部共同制定的《校外培训机构从业人员管理办法（试行）》中的相关要求。</span></p>
        <p><span>6.体育类校外培训机构可聘请持技术等级证书的社会体育指导员开展体育志愿服务。开展高危体育项目的校外体育培训，从业人员必须具备国家规定的职业资格。</span></p>
        <p><span>（二）人员配备</span></p>
        <p><span>体育类校外培训机构应配备与自身规模适应数量的执教人员，按照体育项目特点和培训规模控制学员与执教人员配比。原则上每班次培训的学员人数不超过35人，超过10名学员的培训应至少配有2名执教人员。</span>
        </p>
        <p><span>（三）人员管理</span></p>
        <p><span>体育类校外培训机构应与聘用的从业人员依法签订劳动合同、缴纳社会保险，保障其工资、福利待遇和其他合法权益。</span></p>
        <p><span>对初次招用人员，应当开展岗位培训。体育类校外培训机构应定期组织执教人员参加体育部门组织举办的各级各类职教人员继续教育培训，每季度至少组织一次在职执教人员内部培训，培训时长年度累计不少于90个学时（45分钟计1学时）。</span>
        </p>
        <p><span>体育类校外培训机构应公示执教人员的姓名、照片、资质证书编号等信息；其他服务人员应统一佩戴工牌，包含照片和人员基本信息。体育类校外培训机构应对拟录用的从业人员进行背景审查，受到剥夺政治权利或者故意犯罪受到有期徒刑以上刑事处罚的人员不得录用。</span>
        </p>
        <p><span>体育类校外培训机构应建立学生信息档案，实现一人一档。教职工和学员基本信息应定期分别报当地体育主管部门和教育行政部门备案。</span></p>
        <p><span>七、培训项目内容及材料</span></p>
        <p><span>体育类校外培训机构应根据国家义务教育阶段《体育与健康》课程方案和课程标准的目标及内容，开展与培训对象的年龄、身体状况、运动能力等相匹配的相关专项运动技能项目培训。各地结合地区实际可设置适宜本地区推广普及的，符合青少年身心特点的，深受青少年喜爱的冰雪体育活动、民族民间传统体育活动和其他新兴体育运动项目。</span>
        </p>
        <p><span>体育类校外培训机构应制定与其培训项目相对应的培训计划，合理安排教学内容，采取必要措施防止运动伤害。体育运动项目和体育活动的教育教学培训内容不得违背党的教育方针，不得违反国家相关法律规定。以“健康第一”“以体育人”为目标，符合青少年身心成长及体育运动科学发展规律。</span>
        </p>
        <p><span>体育类校外培训机构所开展的培训项目应落实自主管理责任，严格按照教育部办公厅发布的《义务教育阶段校外培训项目分类鉴别指南》的要求，自觉按照“非学科类”的相关管理要求，规范开展培训活动，不得出现名不符实的情况，不得隐形变异违规开展学科类培训活动。</span>
        </p>
        <p><span>培训材料应符合教育部办公厅印发的《中小学生校外培训材料管理办法（试行）》要求。</span></p>
        <p><span>八、收费管理</span></p>
        <p><span>体育校外培训机构的收费应符合《教育部等六部门关于加强校外培训机构预收费监管工作的通知》及我省的相关规定。全面使用《中小学生校外培训服务合同（示范文本）》。</span></p>
        <p><span>九、其他</span></p>
        <p><span>（一）体育类校外培训机构准入登记实行属地管理，由县级及以上体育主管部门负责。各地应据此制定审批登记办法和监督管理办法，并组织实施。</span></p>
        <p><span>（二）面向各类人群包括青少年群体提供体育训练、运动场所（地）等体育服务的申办者，按照原有管理体制申请设立。</span></p>
        <p><span>（三）开展高危险性体育项目（游泳、攀岩、潜水、滑雪等）培训的机构，须取得《经营高危险性体育项目许可证》。</span></p>
        <p><span>（四）面向3至6岁学龄前儿童、普通高中学生的体育校外培训机构设置应参照本标准执行。</span></p>
        <p><span>（五）本标准自2022年1月1日起试行。</span></p>
      </div>
    </div>

    <!-- Unnamed (矩形) -->
    <router-link to="/">
      <div id="u67" class="ax_default box_2">
        <div id="u67_div" class=""></div>
        <div id="u67_text" class="text ">
          <p><span>返回</span></p>
        </div>
      </div>
    </router-link>
    <!-- Unnamed (矩形) -->

      <div id="u68" class="ax_default box_2" @click="toziliao">
        <div id="u68_div" class=""></div>
        <div id="u68_text" class="text ">
          <p><span>我已阅读并同意</span></p>
        </div>
      </div>

  </div>
</template>

<script>
export default {
  name: 'TiJiao',
  data() {
    return {}
  },
  created() {
  },
  methods: {
    toziliao(){
      localStorage.setItem('type',1)
      this.$router.push('/baobei')
    }
  }
}
</script>
<style scoped>
body {
  margin: 0px;
  background-image: none;
  position: relative;
  left: -0px;
  width: 1000px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}

#base {
  position: absolute;
  z-index: 0;
}

#u60_img {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 1000px;
  height: 227px;
}

#u60 {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 1000px;
  height: 227px;
}

#u60_text {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 0px;
  visibility: hidden;
  word-wrap: break-word;
}

#u61_img {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 342px;
  height: 76px;
}

#u61 {
  border-width: 0px;
  position: absolute;
  left: 32px;
  top: 62px;
  width: 342px;
  height: 76px;
}

#u61_text {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 0px;
  visibility: hidden;
  word-wrap: break-word;
}

#u62_div {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 1000px;
  height: 114px;
  background: inherit;
  background-color: rgba(242, 242, 242, 1);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}

#u62 {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 5650px;
  width: 1000px;
  height: 114px;
}

#u62_text {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 0px;
  visibility: hidden;
  word-wrap: break-word;
}

#u63_img {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 931px;
  height: 2px;
}

#u63 {
  border-width: 0px;
  position: absolute;
  left: 33px;
  top: 307px;
  width: 930px;
  height: 1px;
}

#u63_text {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 0px;
  visibility: hidden;
  word-wrap: break-word;
}

#u64_div {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 559px;
  height: 80px;
  background: inherit;
  background-color: rgba(255, 255, 255, 0);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  line-height: 20px;
}

#u64 {
  border-width: 0px;
  position: absolute;
  left: 221px;
  top: 5650px;
  width: 559px;
  height: 80px;
  line-height: 20px;
}

#u64_text {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 559px;
  white-space: nowrap;
}

#u65_div {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 169px;
  height: 33px;
  background: inherit;
  background-color: rgba(255, 255, 255, 0);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 28px;
}

#u65 {
  border-width: 0px;
  position: absolute;
  left: 416px;
  top: 220px;
  width: 169px;
  height: 33px;
  font-size: 28px;
}

#u65_text {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 169px;
  white-space: nowrap;
}

#u66_div {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 930px;
  height: 3332px;
  background: inherit;
  background-color: rgba(255, 255, 255, 0);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  line-height: 28px;
}

#u66 {
  border-width: 0px;
  position: absolute;
  left: 33px;
  top: 328px;
  width: 930px;
  height: 3332px;
  line-height: 28px;
}

#u66_text {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 930px;
  word-wrap: break-word;
}

#u67_div {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 110px;
  height: 47px;
  background: inherit;
  background-color: rgba(204, 204, 204, 1);
  border: none;
  border-radius: 5px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 18px;
  color: #FFFFFF;
}

#u67 {
  border-width: 0px;
  position: absolute;
  left: 317px;
  top: 5550px;
  width: 110px;
  height: 47px;
  font-size: 18px;
  color: #FFFFFF;
}

#u67_text {
  border-width: 0px;
  position: absolute;
  left: 2px;
  top: -6px;
  text-align: center;
  width: 106px;
  word-wrap: break-word;
}

#u68_div {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 170px;
  height: 47px;
  background: inherit;
  background-color: rgba(0, 153, 255, 1);
  border: none;
  border-radius: 5px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 18px;
  color: #FFFFFF;
}

#u68 {
  border-width: 0px;
  position: absolute;
  left: 445px;
  top: 5550px;
  width: 170px;
  height: 47px;
  font-size: 18px;
  color: #FFFFFF;
  text-align: center;
}

#u68_text {
  border-width: 0px;
  position: absolute;
  left: 2px;
  top: -6px;
  width: 166px;
  word-wrap: break-word;
}


</style>
